import nycSuperheroes from "../../images/Paintings/Peoplescapes_2024-now/1_nycSuperheroes.jpg";
import paris from "../../images/Paintings/Peoplescapes_2024-now/2_paris.jpg";
import theOptimist2 from "../../images/Paintings/Peoplescapes_2024-now/3_theOptimist2.jpg";
import aDayInMalibu from "../../images/Paintings/Peoplescapes_2024-now/4_aDayInMalibu.jpg";

import newtown from "../../images/Paintings/Peoplescapes_2024-now/6_newtown.jpg";
import washingtonSq from "../../images/Paintings/Peoplescapes_2024-now/7_washingtonSq.jpg";
import frigidSaturdayMorning from "../../images/Paintings/Peoplescapes_2024-now/8_fridgidSaturdayMorning.jpg";
import homeHeart from "../../images/Paintings/Peoplescapes_2024-now/9_homeHeart.jpg";
import manly4 from "../../images/Paintings/Peoplescapes_2024-now/10_manly4.jpg";
import cadenceOfBrooklynSummer from "../../images/Paintings/Peoplescapes_2024-now/11_cadenceOfBrooklynSummer.jpg";
import fortGreene from "../../images/Paintings/Peoplescapes_2024-now/12_fortGreene.jpg";
import prospectPark from "../../images/Paintings/Peoplescapes_2024-now/13_prospectPark.jpg";
import lACityMeetsMountains from "../../images/Paintings/Peoplescapes_2024-now/14_lACityMeetsMountains.jpg";
import theFilmSet2 from "../../images/Paintings/Peoplescapes_2024-now/15_theFilmSet2.jpg";
import softServeIceCreamInJune from "../../images/Paintings/Peoplescapes_2024-now/16_softServeIceCreamInJune.jpg";
import meanwhileInNewYork from "../../images/Paintings/Peoplescapes_2024-now/17_meanwhileInNewYork.jpg";
import toaf2024 from "../../images/Paintings/Peoplescapes_2024-now/18_toaf2024.jpg";
import wintersDayBrooklynHeights from "../../images/Paintings/Peoplescapes_2024-now/19_wintersDayBrooklynHeights.jpg";
import steamboatMickeyInSoho from "../../images/Paintings/Peoplescapes_2024-now/20_steamboatMickeyInSoho.jpg";
import aDayInDallas from "../../images/Paintings/Peoplescapes_2024-now/21_aDayInDallas.jpg";
import aDayInDallas2 from "../../images/Paintings/Peoplescapes_2024-now/22_aDayInDallas2.jpg";
import aDayInFortWorth from "../../images/Paintings/Peoplescapes_2024-now/23_aDayInFortWorth.jpg";
import pottsPoint from "../../images/Paintings/Peoplescapes_2024-now/24_pottsPoint.jpg";
import berlin from "../../images/Paintings/Peoplescapes_2024-now/25_berlin.jpg";
import paddingtonVIII from "../../images/Paintings/Peoplescapes_2024-now/26_paddingtonVIII.jpg";
import eastVillage from "../../images/Paintings/Peoplescapes_2024-now/27_eastVillage.jpg";
import aDayInMelbourne from "../../images/Paintings/Peoplescapes_2024-now/28_aDayInMelbourne.jpg";
import gameDayMavericks from "../../images/Paintings/Peoplescapes_2024-now/29_gameDayMavericks.jpg";
import paddingtonIX from "../../images/Paintings/Peoplescapes_2024-now/30_paddingtonIX.jpg";
import filmSetIII from "../../images/Paintings/Peoplescapes_2024-now/31_filmSetIII.jpg";
import pigeonsAndDogs from "../../images/Paintings/Peoplescapes_2024-now/32_pigeonsDogsAndNewYorkers.webp";
import bordersAndSkiers from "../../images/Paintings/Peoplescapes_2024-now/33_bordersSkiersAndSpritzers.jpg";
import ranchoSantaFe from "../../images/Paintings/Peoplescapes_2024-now/34_ranchoSantaFe.jpg";
import miamiBeach from "../../images/Paintings/Peoplescapes_2024-now/35_miamiBeach.jpg";

// 800px responsive versions for srcset
import nycSuperheroesSm from "../../images/Paintings/Peoplescapes_2024-now/sm/1_nycSuperheroes.jpg";
import parisSm from "../../images/Paintings/Peoplescapes_2024-now/sm/2_paris.jpg";
import theOptimist2Sm from "../../images/Paintings/Peoplescapes_2024-now/sm/3_theOptimist2.jpg";
import aDayInMalibuSm from "../../images/Paintings/Peoplescapes_2024-now/sm/4_aDayInMalibu.jpg";
import newtownSm from "../../images/Paintings/Peoplescapes_2024-now/sm/6_newtown.jpg";
import washingtonSqSm from "../../images/Paintings/Peoplescapes_2024-now/sm/7_washingtonSq.jpg";
import frigidSaturdayMorningSm from "../../images/Paintings/Peoplescapes_2024-now/sm/8_fridgidSaturdayMorning.jpg";
import homeHeartSm from "../../images/Paintings/Peoplescapes_2024-now/sm/9_homeHeart.jpg";
import manly4Sm from "../../images/Paintings/Peoplescapes_2024-now/sm/10_manly4.jpg";
import cadenceOfBrooklynSummerSm from "../../images/Paintings/Peoplescapes_2024-now/sm/11_cadenceOfBrooklynSummer.jpg";
import fortGreeneSm from "../../images/Paintings/Peoplescapes_2024-now/sm/12_fortGreene.jpg";
import prospectParkSm from "../../images/Paintings/Peoplescapes_2024-now/sm/13_prospectPark.jpg";
import lACityMeetsMountainsSm from "../../images/Paintings/Peoplescapes_2024-now/sm/14_lACityMeetsMountains.jpg";
import theFilmSet2Sm from "../../images/Paintings/Peoplescapes_2024-now/sm/15_theFilmSet2.jpg";
import softServeIceCreamInJuneSm from "../../images/Paintings/Peoplescapes_2024-now/sm/16_softServeIceCreamInJune.jpg";
import meanwhileInNewYorkSm from "../../images/Paintings/Peoplescapes_2024-now/sm/17_meanwhileInNewYork.jpg";
import toaf2024Sm from "../../images/Paintings/Peoplescapes_2024-now/sm/18_toaf2024.jpg";
import wintersDayBrooklynHeightsSm from "../../images/Paintings/Peoplescapes_2024-now/sm/19_wintersDayBrooklynHeights.jpg";
import steamboatMickeyInSohoSm from "../../images/Paintings/Peoplescapes_2024-now/sm/20_steamboatMickeyInSoho.jpg";
import aDayInDallasSm from "../../images/Paintings/Peoplescapes_2024-now/sm/21_aDayInDallas.jpg";
import aDayInDallas2Sm from "../../images/Paintings/Peoplescapes_2024-now/sm/22_aDayInDallas2.jpg";
import aDayInFortWorthSm from "../../images/Paintings/Peoplescapes_2024-now/sm/23_aDayInFortWorth.jpg";
import pottsPointSm from "../../images/Paintings/Peoplescapes_2024-now/sm/24_pottsPoint.jpg";
import berlinSm from "../../images/Paintings/Peoplescapes_2024-now/sm/25_berlin.jpg";
import paddingtonVIIISm from "../../images/Paintings/Peoplescapes_2024-now/sm/26_paddingtonVIII.jpg";
import eastVillageSm from "../../images/Paintings/Peoplescapes_2024-now/sm/27_eastVillage.jpg";
import aDayInMelbourneSm from "../../images/Paintings/Peoplescapes_2024-now/sm/28_aDayInMelbourne.jpg";
import gameDayMavericksSm from "../../images/Paintings/Peoplescapes_2024-now/sm/29_gameDayMavericks.jpg";
import paddingtonIXSm from "../../images/Paintings/Peoplescapes_2024-now/sm/30_paddingtonIX.jpg";
import filmSetIIISm from "../../images/Paintings/Peoplescapes_2024-now/sm/31_filmSetIII.jpg";
import pigeonsAndDogsSm from "../../images/Paintings/Peoplescapes_2024-now/sm/32_pigeonsDogsAndNewYorkers.webp";
import bordersAndSkiersSm from "../../images/Paintings/Peoplescapes_2024-now/sm/33_bordersSkiersAndSpritzers.jpg";
import ranchoSantaFeSm from "../../images/Paintings/Peoplescapes_2024-now/sm/34_ranchoSantaFe.jpg";
import miamiBeachSm from "../../images/Paintings/Peoplescapes_2024-now/sm/35_miamiBeach.jpg";

const peopleScapesNewCollection = [
  {
    image: nycSuperheroes,
    imageSm: nycSuperheroesSm,
    title: "The Superheroes and a Photoshoot (New York)",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2024",
    alt: "The Superheroes and a Photoshoot (New York). Oil & acrylic on linen. 71cm x 71cm. 2024",
  },
  {
    image: pottsPoint,
    imageSm: pottsPointSm,
    title: "Potts Point",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2026",
    alt: "Potts Point. Oil & acrylic on linen. 71cm x 71cm. 2026",
  },
  {
    image: berlin,
    imageSm: berlinSm,
    title: "A Day in Berlin",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2026",
    alt: "A Day in Berlin. Oil & acrylic on linen. 71cm x 71cm. 2026",
  },
  {
    image: paddingtonVIII,
    imageSm: paddingtonVIIISm,
    title: "Paddington VIII",
    description: "Oil & acrylic on linen. 163cm x 163cm. 2025",
    alt: "Paddington VIII. Oil & acrylic on linen. 163cm x 163cm. 2025",
  },
  {
    image: paris,
    imageSm: parisSm,
    title: "Paris- A Moveable Feast",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2024",
    alt: "Paris- A Moveable Feast. Oil & acrylic on linen. 71cm x 71cm. 2024",
  },
  {
    image: theOptimist2,
    imageSm: theOptimist2Sm,
    title: "The Optimist II",
    description: "Oil & acrylic on linen. 122cm x 101cm. 2023/2024",
    alt: "The Optimist II. Oil & acrylic on linen. 122cm x 101cm. 2023/2024",
  },
  {
    image: aDayInMalibu,
    imageSm: aDayInMalibuSm,
    title: "A Day in Malibu",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2024",
    alt: "A Day in Malibu. Oil & acrylic on linen. 152cm x 152cm. 2024",
  },
  {
    image: newtown,
    imageSm: newtownSm,
    title: "A Day in Newtown",
    description: "Oil & acrylic on linen. 102cm x 122cm. 2025",
    alt: "A Day in Newtown. Oil & acrylic on linen. 102cm x 122cm. 2025",
  },
  {
    image: washingtonSq,
    imageSm: washingtonSqSm,
    title: "Washington Square Park NYC",
    description: "Oil & acrylic on linen. 91cm x 91cm. 2024",
    alt: "Washington Square Park NYC. Oil & acrylic on linen. 91cm x 91cm. 2024",
  },
  {
    image: frigidSaturdayMorning,
    imageSm: frigidSaturdayMorningSm,
    title: "Frigid Saturday Morning",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2024",
    alt: "Frigid Saturday Morning. Oil & acrylic on linen. 152cm x 152cm. 2024",
  },
  {
    image: homeHeart,
    imageSm: homeHeartSm,
    title: "Home is Where the Heart is",
    description: "Oil & acrylic on linen. 183cm x 183cm. 2024/2025",
    alt: "Home is Where the Heart is. Oil & acrylic on linen. 183cm x 183cm. 2024/2025",
  },
  {
    image: manly4,
    imageSm: manly4Sm,
    title: "Manly IV",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2025",
    alt: "Manly IV. Oil & acrylic on linen. 152cm x 152cm. 2025",
  },
  {
    image: cadenceOfBrooklynSummer,
    imageSm: cadenceOfBrooklynSummerSm,
    title: "Cadence of a Brooklyn Summer",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2024",
    alt: "Cadence of a Brooklyn Summer. Oil & acrylic on linen. 152cm x 152cm. 2024",
  },
  {
    image: fortGreene,
    imageSm: fortGreeneSm,
    title: "Fort Greene- Brooklyn",
    description: "Oil & Acrylic on linen. 122cm X 152cm. 2024",
    alt: "Fort Greene- Brooklyn. Oil & Acrylic on linen. 122cm X 152cm. 2024",
  },
   {
    image: prospectPark,
    imageSm: prospectParkSm,
    title: "Prospect Park- Brooklyn",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2024",
    alt: "Prospect Park- Brooklyn. Oil & acrylic on linen. 71cm x 71cm. 2024",
  },
  {
    image: lACityMeetsMountains,
    imageSm: lACityMeetsMountainsSm,
    title: "Los Angeles- City meets the mountains",
    description: "Oil & Acrylic on linen. 122cm X 152cm. 2024",
    alt: "Los Angeles- City meets the mountains. Oil & Acrylic on linen. 122cm X 152cm. 2024",
  },
  {
    image: theFilmSet2,
    imageSm: theFilmSet2Sm,
    title: "The Film Set II",
    description: "Oil & Acrylic on linen. 102cm X 122cm. 2024",
    alt: "The Film Set II. Oil & Acrylic on linen. 102cm X 122cm. 2024",
  },
  {
    image: filmSetIII,
    imageSm: filmSetIIISm,
    title: "The Film Set III: Hollywood",
    description: "Oil & acrylic on linen. 76cm x 76cm. 2025/2026",
    alt: "The Film Set III: Hollywood. Oil & acrylic on linen. 76cm x 76cm. 2025/2026",
  },
  {
    image: softServeIceCreamInJune,
    imageSm: softServeIceCreamInJuneSm,
    title: "Soft Serve Ice Cream in June",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2024",
    alt: "Soft Serve Ice Cream in June. Oil & acrylic on linen. 71cm x 71cm. 2024",
  },
  {
    image: meanwhileInNewYork,
    imageSm: meanwhileInNewYorkSm,
    title: "Meanwhile in New York",
    description: "Oil & acrylic on linen. 36cm x 41cm. 2025",
    alt: "Meanwhile in New York. Oil & acrylic on linen. 36cm x 41cm. 2025",
  },
  {
    image: toaf2024,
    imageSm: toaf2024Sm,
    title: "The Other Art Fair- Brooklyn",
    description: "May 2024",
    alt: "The Other Art Fair- Brooklyn. May 2024",
  },
  {
    image: wintersDayBrooklynHeights,
    imageSm: wintersDayBrooklynHeightsSm,
    title: "Winters Day Brooklyn Heights",
    description: "Oil & Acrylic on linen. 61cm X 61cm. 2024",
    alt: "Winters Day Brooklyn Heights. Oil & Acrylic on linen. 61cm X 61cm. 2024",
  },
  {
    image: steamboatMickeyInSoho,
    imageSm: steamboatMickeyInSohoSm,
    title: "Steamboat Mickey in Soho",
    description: "Oil & Acrylic on linen. 71cm X 71cm. 2023/2024",
    alt: "Steamboat Mickey in Soho. Oil & Acrylic on linen. 71cm X 71cm. 2023/2024",
  },
  {
    image: aDayInDallas,
    imageSm: aDayInDallasSm,
    title: "A Day in Dallas",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2025",
    alt: "A Day in Dallas. Oil & acrylic on linen. 152cm x 152cm. 2025",
  },
  {
    image: aDayInDallas2,
    imageSm: aDayInDallas2Sm,
    title: "A Day in Dallas II",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2025",
    alt: "A Day in Dallas II. Oil & acrylic on linen. 152cm x 152cm. 2025",
  },
  {
    image: aDayInFortWorth,
    imageSm: aDayInFortWorthSm,
    title: "A Day in Fort Worth Texas",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2025",
    alt: "A Day in Fort Worth Texas. Oil & acrylic on linen. 152cm x 152cm. 2025",
  },
 {
    image: eastVillage,
    imageSm: eastVillageSm,
    title: "A Day in East Village",
    description: "Oil & acrylic on linen. 122cm x 122cm. 2025",
    alt: "A Day in East Village. Oil & acrylic on linen. 122cm x 122cm. 2025",
  },
  {
    image: aDayInMelbourne,
    imageSm: aDayInMelbourneSm,
    title: "A Day in Melbourne",
    description: "Oil & acrylic on linen. 91cm x 91cm. 2025",
    alt: "A Day in Melbourne. Oil & acrylic on linen. 91cm x 91cm. 2025",
  },  
  {
    image: gameDayMavericks,
    imageSm: gameDayMavericksSm,
    title: "Game Day: Mavericks",
    description: "Oil & acrylic on linen. 41cm x 35cm. 2025",
    alt: "Game Day Mavericks. Oil & acrylic on linen. 41cm x 35cm. 2025",
  },
  {
    image: paddingtonIX,
    imageSm: paddingtonIXSm,
    title: "Paddington IX",
    description: "Oil & acrylic on linen. 122cm x 183cm. 2025",
    alt: "Paddington IX. Oil & acrylic on linen. 122cm x 183cm. 2025",
  },
  {
    image: pigeonsAndDogs,
    imageSm: pigeonsAndDogsSm,
    title: "Pigeons, Dogs, and New Yorkers",
    description: "Oil & acrylic on linen. 91cm x 86cm. 2023-2026",
    alt: "Pigeons, Dogs and New Yorkers. Oil & acrylic on linen. 91cm x 86cm. 2023-2026",
  },
  {
    image: bordersAndSkiers,
    imageSm: bordersAndSkiersSm,
    title: "Borders, Skiers, and Spritzers",
    description: "Oil & acrylic on linen. 91cm x 86cm. 2023-2026",
    alt: "Borders, Skiers, and Spritzers. Oil & acrylic on linen. 91cm x 86cm. 2023-2026",
  },
  {
    image: ranchoSantaFe,
    imageSm: ranchoSantaFeSm,
    title: "Rancho Santa Fe, CA",
    description: "Oil & acrylic on linen. 92cm x 92cm. 2026",
    alt: "Rancho Santa Fe, CA. Oil & acrylic on linen. 92cm x 92cm. 2026",
  },
  {
    image: miamiBeach,
    imageSm: miamiBeachSm,
    title: "Miami Beach, FL",
    description: "Oil & acrylic on linen. 51cm x 51cm. 2026",
    alt: "Miami Beach, FL. Oil & acrylic on linen. 51cm x 51cm. 2026",
  },
  ];

export default peopleScapesNewCollection;
